import {
  GoogleAuthProvider,
  TwitterAuthProvider,
  User,
  createUserWithEmailAndPassword,
  // onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  linkWithPopup,
  // signOut,
  sendEmailVerification,
  getAdditionalUserInfo,
  AdditionalUserInfo,
} from 'firebase/auth';
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { auth } from '../api/firebase/utils';
import { OnboardingPhases, UserEntity } from 'core/models/users/user.model';
import { UserV1BaseServerRepo } from 'core/repository/base-server/v1/user.repo';
import {
  PostCreateOrLoadUserRequest,
  PostCreateOrLoadUserResponse,
} from 'core/models/users/post-create-load-user.model';
import { AppConfigV1BaseServerRepo } from 'core/repository/base-server/v1/app-config.repo';
import useGlobalStore from 'stores/globalStore';
import { useNotify } from './notify.context';
import { setPersistence, browserLocalPersistence } from 'firebase/auth';
import { usePrivy } from '@privy-io/react-auth';
import { useLocation, useNavigate } from 'react-router-dom';
// import { ProjectV1BaseServerRepo } from 'core/repository/base-server/v1/project.repo';
import { ROUTES } from 'routes';
// import axios from 'axios';
// import { RestrictedCountry } from 'core/models/app-config/get-app-config-by-key.model';
// import { restrictedCountries } from 'components/geo-block/countryList';

interface AuthContextProps {
  user: User | null;
  userProfile: UserEntity | null;
  handleProfileCreationOrLoad: () => Promise<PostCreateOrLoadUserResponse>;
  isLoggedIn: boolean;
  isCheckingAuth: boolean;
  btnLoading: boolean;
  signInWithGoogle: () => Promise<void>;
  signInWithTwitter: () => Promise<void>;
  signUpWithEmail: (email: string, password: string) => Promise<void>;
  signInWithEmail: (email: string, password: string) => Promise<void>;
  changeUserPassword: (
    password: string,
    setLoading: (value: boolean) => void
  ) => void;
  logOut: () => Promise<void>;
  linkToTwitter: () => Promise<AdditionalUserInfo>;
  setUserProfile: React.Dispatch<React.SetStateAction<UserEntity | null>>;
  handleResendEmailVerification: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextProps | undefined>(
  undefined
);
AuthContext.displayName = 'AuthContext';

export const useAuth = (): AuthContextProps => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error(`useAuth must be used within an AuthProvider`);
  }
  return context;
};

export const AuthProvider = (props: any) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>();
  const [user, setUser] = useState<User | null>(null);
  const [userProfile, setUserProfile] = useState<UserEntity | null>(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const { setCryptoNetworks } = useGlobalStore();
  const { notifyError } = useNotify();
  const { logout, user: privyUser } = usePrivy();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // console.log('user--', user);
  const handleProfileCreationOrLoad =
    async (): Promise<PostCreateOrLoadUserResponse> => {
      const request: PostCreateOrLoadUserRequest = {};
      const response = await new UserV1BaseServerRepo().createOrLoad(request);
      try {
        setUserProfile(response);
        if (
          response.onboardingPhase !== OnboardingPhases.DONE &&
          (pathname === '/dashboard' ||
            pathname.includes('/project') ||
            pathname === '/profile')
        ) {
          navigate(ROUTES.LANDING);
        } else if (
          response.onboardingPhase === OnboardingPhases.DONE &&
          response.roles?.includes('PROJECT_OWNER')
        ) {
          if (
            pathname === '/dashboard' ||
            pathname.includes('/project') ||
            pathname === '/profile'
          ) {
            // const appProjects =
            //   await new ProjectV1BaseServerRepo().getProjects();
            // if (
            //   appProjects.data.length &&
            //   appProjects.data[0].status !== 'APPROVED'
            // ) {
            navigate(ROUTES.APPLICATION_IN_REVIEW);
            // }
          }
        }
      } catch (error) {
        notifyError(
          'Something went wrong while creating or loading your profile. Please try again later.'
        );
      }
      return response;
    };

  const checkAuthState = async () => {
    // onAuthStateChanged(auth, (user) => {
    const privyIdToken = localStorage.getItem('privy:id_token');
    if (privyIdToken) {
      // setUser(user);
      setIsLoggedIn(true);
      // const isSmartWallet = localStorage.getItem('smartWallet');
      // if (!isSmartWallet) {
      //   try {
      //     await new UserV1BaseServerRepo().smartWallet({});
      //     localStorage.setItem('smartWallet', JSON.stringify(true));
      //   } catch (error) {
      //     console.log('Smart wallet error--', error);
      //   }
      // }

      handleProfileCreationOrLoad();
    } else {
      setUser(null);
      setIsLoggedIn(false);
      setUserProfile(null);
    }
    // });
  };

  useEffect(() => {
    async function load() {
      await startupApiCalls();
    }

    load();
  }, []);

  useEffect(() => {
    function load() {
      checkAuthState();
    }

    load();
  }, [privyUser]);

  // useEffect(() => {
  //   if (userProfile) {
  //     fetchCOuntry();
  //   }
  // }, [userProfile]);

  // const fetchCOuntry = async () => {
  //   try {
  //     const countryResponse = await axios.get(
  //       'https://get.geojs.io/v1/ip/country.json'
  //     );
  //     if (
  //       restrictedCountries
  //         .map((c: RestrictedCountry) => c.code)
  //         .includes(countryResponse.data.country) &&
  //       userProfile?.roles?.length === 1 &&
  //       userProfile?.roles.includes('MEMBER')
  //     ) {
  //       navigate(ROUTES.GEO_BLOCK);
  //     }
  //     // console.log('IP--response--',response)
  //   } catch (error) {
  //     console.log('Error:--', error);
  //   }
  // };

  // console.log('privyUser--', privyUser);
  // useEffect(() => {
  //   const unsubscribe = () => {
  //     if (user) {
  //       setUser(user);
  //       localStorage.setItem('authUser', JSON.stringify(user));
  //     } else {
  //       setUser(null);
  //       localStorage.removeItem('authUser');
  //     }
  //   };

  //   return () => unsubscribe();
  // }, []);

  // useEffect(() => {
  //   const storedUser = localStorage.getItem('authUser');
  //   if (storedUser) {
  //     setUser(JSON.parse(storedUser));
  //   }
  // }, []);

  const startupApiCalls = async () => {
    const repo = new AppConfigV1BaseServerRepo();

    try {
      const networks = await repo.getCryptoNetworks();
      setCryptoNetworks(networks);
    } catch (error) {
      console.log(error);
    }
  };

  const signInWithGoogle = async (): Promise<void> => {
    try {
      setBtnLoading(true);
      await setPersistence(auth, browserLocalPersistence); // Ensures session is persisted across reloads
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account',
      });
      await signInWithPopup(auth, provider);
      setBtnLoading(false);
    } catch (error) {
      console.log(error);
      if (error instanceof Error) {
        const errorMessage = error.message;
        console.log(errorMessage);
        notifyError(errorMessage);
      }
      setBtnLoading(false);
      throw new Error('Error signing in with Google');
    }
  };

  const signInWithTwitter = async (): Promise<void> => {
    try {
      setBtnLoading(true);
      const provider = new TwitterAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account',
      });
      await signInWithPopup(auth, provider);
      setBtnLoading(false);
    } catch (error) {
      console.log(error);
      if (error instanceof Error) {
        const errorMessage = error.message;
        console.log(errorMessage);
        notifyError(errorMessage);
      }
      setBtnLoading(false);
    }
  };

  const signInWithEmail = async (
    email: string,
    password: string
  ): Promise<void> => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (error: any) {
      notifyError(error?.message! || 'Error signing in with email');
      throw new Error('Error signing in with email');
    }
  };

  const signUpWithEmail = async (email: string, password: string) => {
    setBtnLoading(true);
    try {
      const response = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      sendEmailVerification(response.user);
      setBtnLoading(false);
    } catch (error: any) {
      const errorMessage = error.message;
      notifyError(errorMessage);
      setBtnLoading(false);
      throw error;
    }
  };

  const resetPassword = (email: string, successCallback: any) => {
    setBtnLoading(true);

    sendPasswordResetEmail(auth, email)
      .then(() => {
        successCallback();
        setBtnLoading(false);
      })
      .catch((error) => {
        const errorMessage = error.message;
        notifyError(errorMessage);
        setBtnLoading(false);
      });
  };

  const linkToTwitter = async (): Promise<AdditionalUserInfo | null | void> => {
    const provider = new TwitterAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account',
    });

    const result = await linkWithPopup(user!, provider);

    if (result) {
      return getAdditionalUserInfo(result);
    }
  };

  const logOut = async (): Promise<void> => {
    logout();
    localStorage.removeItem('smartWallet');
    setIsLoggedIn(false);
    // await signOut(auth);
  };

  const handleResendEmailVerification = async (): Promise<void> => {
    return sendEmailVerification(user!);
  };

  const value = useMemo(
    () => ({
      user,
      userProfile,
      handleProfileCreationOrLoad,
      isLoggedIn,
      btnLoading,
      signInWithGoogle,
      signInWithTwitter,
      logOut,
      setUserProfile,
      signInWithEmail,
      signUpWithEmail,
      resetPassword,
      linkToTwitter,
      handleResendEmailVerification,
    }),
    [user, userProfile, isLoggedIn, btnLoading, handleResendEmailVerification]
  );

  return <AuthContext.Provider value={value} {...props} />;
};
